export default "__VITE_ASSET__eJMolLE___"